import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
    summary_list_wrapper: ({ isXs }) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: '3.2rem',
        width: '100%',
        padding: '0 1.1rem',
        marginBottom: isXs ? '18rem' : '15rem'
    }),
    summary_list_header: ({ ccquEnabled }) => ({
        fontSize: '1.8rem',
        fontWeight: '500',
        marginBottom: '-1.6rem',
        color: ccquEnabled ? '#001464' : '#333333'
    }),
    ccquDisclaimer: {
        marginTop: '-1.5rem',
        marginBottom: '-2rem',
        color: '#404756'
    }
});
